// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3KQec","search":"Settings_search__1JqZe","filter":"Settings_filter__2cLaT"};